(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('receivables', {
            parent: 'application',
            url: '/receivables',
            data: {
                pageTitle: 'global.menu.receivables'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/receivables/receivables.html',
                    controller: 'ReceivablesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('receivables');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
